import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import { useNavigate } from "react-router-dom";

import BirthdayPopup from './BirthdayPopup';

function DashboardElement() {
    const accesstoken = localStorage.getItem("token");

    // Username
    const username = localStorage
        .getItem("username")
        ?.replace(/^./, c => c.toUpperCase());

    // Staff ID
    const assign_staffid = localStorage.getItem("staffid");

    // States
    const [data, setData] = useState([]);

    const [allAssignments, setAllAssignments] = useState({
        assignment_data: [],
        shiftmode_data: [],
    });

    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [disablePunch, setDisablePunch] = useState(false);
    const Swal = require('sweetalert2')
    let navigate = useNavigate();

    // Face enrollment modal state
    const [enrollModalOpen, setEnrollModalOpen] = useState(false);
    const [enrollSamples, setEnrollSamples] = useState([]);
    const [enrollValidating, setEnrollValidating] = useState(false);
    const [faceLoading, setFaceLoading] = useState(false);
    const [faceCameraActive, setFaceCameraActive] = useState(false);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);

    const ENROLL_STEPS = [
        { label: "Look straight at the camera", icon: "⬆" },
        { label: "Slowly turn slightly to the LEFT", icon: "⬅" },
        { label: "Slowly turn slightly to the RIGHT", icon: "➡" },
    ];

    useEffect(() => {

        if (!assign_staffid) return;

        axios.get(baseurladdress + `checkface/${assign_staffid}`, {
            headers: {
                Authorization: `Bearer ${accesstoken}`
            }
        })
            .then((res) => {

                console.log("Face API Response :", res.data);

                if (res.data.face_exists === 1) {
                    setDisablePunch(true);
                } else {
                    setDisablePunch(false);
                }

            })
            .catch((err) => {
                console.log(err);
            });

    }, [assign_staffid]);
    // Fetch Today's Shift
    useEffect(() => {

        if (!assign_staffid) {

            setLoading(false);
            return;

        }

        setLoading(true);

        axios
            .get(`http://localhost:7500/getassigntoday/${assign_staffid}`)

            .then((response) => {

                console.log(response.data);

                if (response.data.status) {

                    setData(response.data.data);

                } else {

                    setData([]);

                }

                setLoading(false);

            })

            .catch((error) => {

                console.log(error);

                setData([]);
                setLoading(false);

            });

    }, [assign_staffid]);

    // Fetch All Assignments
    const handleViewAssignments = () => {

        axios
            .get(`http://localhost:7500/getassign/${assign_staffid}`)

            .then((response) => {

                console.log(response.data);

                setAllAssignments({
                    assignment_data: response.data.assignment_data || [],
                    shiftmode_data: response.data.shiftmode_data || [],
                });

                setShowModal(true);

            })

            .catch((error) => {

                console.log(error);

            });

    };
    const startCamera = useCallback(async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { width: 640, height: 480 } });
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                await videoRef.current.play();
            }
            setFaceCameraActive(true);
        } catch (e) {
            Swal.fire({ icon: "error", title: "Camera Error", text: "Unable to access camera. Please allow camera permission." });
        }
    }, []);

    const stopCamera = useCallback(() => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach((t) => t.stop());
            streamRef.current = null;
        }
        setFaceCameraActive(false);
    }, []);

    const captureFrame = useCallback(() => {
        if (!videoRef.current || !canvasRef.current) return null;
        const video = videoRef.current;
        const canvas = canvasRef.current;
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 480;
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/jpeg", 0.9);
    }, []);

    const closeEnrollModal = () => {
        stopCamera();
        setEnrollModalOpen(false);
        setFaceLoading(false);
        setEnrollSamples([]);
        setEnrollValidating(false);
    };

    const handleEnrollStep = async () => {
        const imageBase64 = captureFrame();
        if (!imageBase64) return;
        setEnrollValidating(true);
        try {
            const res = await axios.post(
                baseurladdress + "face-validate-sample",
                { imageBase64 },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );
            if (res.data.valid) {
                setEnrollSamples((prev) => [...prev, imageBase64]);
            }
        } catch (err) {
            Swal.fire({
                icon: "warning",
                title: `Sample ${enrollSamples.length + 1} Not Accepted`,
                text: err.response?.data?.message || "Could not validate this sample. Try again.",
            });
        } finally {
            setEnrollValidating(false);
        }
    };

    const handleEnrollRetake = () => {
        setEnrollSamples((prev) => prev.slice(0, -1));
    };

    const handleEnrollSubmit = async () => {
        setFaceLoading(true);
        try {
            const res = await axios.post(
                baseurladdress + "face-enroll",
                { staffid: assign_staffid, images: enrollSamples },
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );
            if (res.data.success) {
                setDisablePunch(true);
                closeEnrollModal();
                Swal.fire({
                    icon: "success",
                    title: "Face Enrolled!",
                    text: `Face registered using ${res.data.samples} angle${res.data.samples > 1 ? "s" : ""} for better accuracy.`,
                    timer: 2500,
                    showConfirmButton: false,
                });
            } else {
                setEnrollSamples([]);
                setFaceLoading(false);
                Swal.fire({ icon: "error", title: "Enrollment Failed", text: res.data.message || "Please try again." });
            }
        } catch (err) {
            setEnrollSamples([]);
            setFaceLoading(false);
            Swal.fire({ icon: "error", title: "Enrollment Failed", text: err.response?.data?.message || "Something went wrong. Please try again." });
        }
    };

    const handlePunchClick = () => {
        if (disablePunch) return;
        setEnrollSamples([]);
        setEnrollModalOpen(true);
        setTimeout(() => startCamera(), 300);
    };
    return (

        <>
            <BirthdayPopup />
            <div className="content-wrap">

                <div className="main">

                    <div className="container-fluid">

                        {/* Welcome */}
                        <div className="row">

                            <div className="col-lg-12">

                                <div className="page-header mb-3">

                                    <div className="page-title">

                                        <h2
                                            style={{
                                                fontWeight: "700",
                                                color: "#4e3f39",
                                            }}
                                        >
                                            Hello, Welcome {username} 😊
                                        </h2>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* Shift Card */}
                        <div className="row mt-4">

                            <div className="col-xl-4 col-lg-5 col-md-8 col-sm-12">

                                {loading ? (

                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{
                                            minHeight: "250px",
                                        }}
                                    >

                                        <div
                                            className="spinner-border"
                                            style={{
                                                color: "#16a34a",
                                            }}
                                            role="status"
                                        >
                                            <span className="visually-hidden">
                                                Loading...
                                            </span>
                                        </div>

                                    </div>

                                ) : (

                                    <>
                                        {data.length > 0 ? (

                                            data.map((item, index) => {

                                                const endDate = new Date(item.to_date);

                                                const today = new Date();

                                                const timeDifference = endDate - today;

                                                const remainingDays = Math.ceil(
                                                    timeDifference / (1000 * 60 * 60 * 24)
                                                );

                                                return (

                                                    <div
                                                        key={index}
                                                        style={{
                                                            background: "#ffffff",
                                                            borderRadius: "22px",
                                                            padding: "20px",
                                                            boxShadow: "0 8px 24px rgba(15,23,42,0.06)",
                                                            fontFamily: "'Inter', sans-serif",
                                                        }}
                                                    >

                                                        {/* TOP */}
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                marginBottom: "18px",
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    fontSize: "15px",
                                                                    fontWeight: "600",
                                                                    color: "#081028",
                                                                }}
                                                            >
                                                                Today's Shift
                                                            </div>

                                                            <div
                                                                style={{
                                                                    background: "#ecfdf3",
                                                                    color: "#16a34a",
                                                                    padding: "6px 12px",
                                                                    borderRadius: "10px",
                                                                    fontSize: "11px",
                                                                    fontWeight: "700",
                                                                    letterSpacing: "0.5px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "6px",
                                                                }}
                                                            >

                                                                <div
                                                                    style={{
                                                                        width: "7px",
                                                                        height: "7px",
                                                                        borderRadius: "50%",
                                                                        background: "#16a34a",
                                                                    }}
                                                                ></div>

                                                                ACTIVE

                                                            </div>

                                                        </div>

                                                        {/* SHIFT SECTION */}
                                                        <div
                                                            style={{
                                                                background: "#f8fafc",
                                                                borderRadius: "18px",
                                                                padding: "16px",
                                                                marginBottom: "16px",
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    gap: "12px",
                                                                    alignItems: "center",
                                                                    marginBottom: "14px",
                                                                }}
                                                            >

                                                                <div
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        borderRadius: "14px",
                                                                        background: "#eaf9ef",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: "22px",
                                                                    }}
                                                                >
                                                                    🌙
                                                                </div>

                                                                <div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            fontWeight: "700",
                                                                            color: "#081028",
                                                                            marginBottom: "4px",
                                                                        }}
                                                                    >
                                                                        {item.shift_name}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            color: "#6b7280",
                                                                        }}
                                                                    >
                                                                        {item.branch_name}
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            {/* TIME */}
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                }}
                                                            >

                                                                <div>

                                                                    <small
                                                                        style={{
                                                                            display: "block",
                                                                            fontSize: "11px",
                                                                            color: "#7b8496",
                                                                            marginBottom: "4px",
                                                                        }}
                                                                    >
                                                                        Start
                                                                    </small>

                                                                    <h4
                                                                        style={{
                                                                            fontSize: "15px",
                                                                            color: "#081028",
                                                                            margin: 0,
                                                                        }}
                                                                    >

                                                                        {new Date(`1970-01-01T${item.type_from}`).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true,
                                                                        })}

                                                                    </h4>

                                                                </div>

                                                                <div
                                                                    style={{
                                                                        color: "#94a3b8",
                                                                        fontSize: "18px",
                                                                    }}
                                                                >
                                                                    →
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        textAlign: "right",
                                                                    }}
                                                                >

                                                                    <small
                                                                        style={{
                                                                            display: "block",
                                                                            fontSize: "11px",
                                                                            color: "#7b8496",
                                                                            marginBottom: "4px",
                                                                        }}
                                                                    >
                                                                        End
                                                                    </small>

                                                                    <h4
                                                                        style={{
                                                                            fontSize: "15px",
                                                                            color: "#081028",
                                                                            margin: 0,
                                                                        }}
                                                                    >

                                                                        {new Date(`1970-01-01T${item.type_to}`).toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true,
                                                                        })}

                                                                    </h4>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* Punch */}
                                                        <div
                                                            style={{
                                                                background: "#eefaf0",
                                                                borderRadius: "14px",
                                                                padding: "14px 16px",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                marginBottom: "16px",
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "#16a34a",
                                                                    fontWeight: "600",
                                                                }}
                                                            >
                                                                Punch In Time
                                                            </div>

                                                            <div
                                                                style={{
                                                                    fontSize: "14px",
                                                                    fontWeight: "700",
                                                                    color:
                                                                        item.punch_status === "Punch In"
                                                                            ? "#081028"
                                                                            : "#dc2626",

                                                                    whiteSpace: "nowrap",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px",
                                                                }}
                                                            >

                                                                {item.attendance_punching
                                                                    ? new Date(item.attendance_punching)
                                                                        .toLocaleTimeString([], {
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: true,
                                                                        })
                                                                    : "Not Punched"}

                                                            </div>

                                                        </div>

                                                        {/* Footer */}
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    fontSize: "13px",
                                                                    fontWeight: "600",
                                                                    color: "#16a34a",
                                                                }}
                                                            >

                                                                {remainingDays > 0
                                                                    ? `${remainingDays} day${remainingDays > 1 ? "s" : ""} remaining`
                                                                    : "Shift Completed"}

                                                            </div>

                                                            <button
                                                                onClick={handleViewAssignments}
                                                                style={{
                                                                    border: "none",
                                                                    background: "#16a34a",
                                                                    color: "#ffffff",
                                                                    padding: "10px 16px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "600",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                View Details
                                                            </button>

                                                        </div>

                                                    </div>

                                                );

                                            })

                                        ) : (

                                            <div
                                                style={{
                                                    background: "#ffffff",
                                                    borderRadius: "22px",
                                                    padding: "30px",
                                                    textAlign: "center",
                                                    boxShadow: "0 8px 24px rgba(15,23,42,0.06)",
                                                }}
                                            >

                                                <h6
                                                    style={{
                                                        color: "#8d8178",
                                                        margin: 0,
                                                    }}
                                                >
                                                    No Shift has been assigned for today...
                                                </h6>

                                            </div>

                                        )}

                                    </>

                                )}

                            </div>
                            {/* ================= Staff Enrollment ================= */}
                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="card border-0 shadow-sm"
                                    style={{
                                        borderRadius: "20px",
                                        overflow: "hidden",
                                    }}
                                >
                                    {/* Header */}
                                    <div
                                        className="d-flex justify-content-between align-items-center"
                                        style={{
                                            padding: "18px 22px",
                                            borderBottom: "1px solid #f3f4f6",
                                        }}
                                    >
                                        <div>
                                            <h5
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: "700",
                                                    color: "#1f2937",
                                                    marginBottom: "3px",
                                                }}
                                            >
                                                Staff Face Enrollment
                                            </h5>

                                          
                                        </div>

                                        <span
                                            className={`badge ${disablePunch
                                                    ? "bg-success"
                                                    : "bg-danger"
                                                }`}
                                            style={{
                                                padding: "8px 15px",
                                                fontSize: "12px",
                                                borderRadius: "25px",
                                                fontWeight: "600",
                                            }}
                                        >
                                            ● {disablePunch ? "ENROLLED" : "NOT ENROLLED"}
                                        </span>
                                    </div>

                                    {/* Center */}
                                    <div
                                        className="d-flex flex-column justify-content-center align-items-center"
                                        style={{
                                            padding: "15px 15px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "75px",
                                                height: "75px",
                                                borderRadius: "50%",
                                                background: disablePunch
                                                    ? "#dcfce7"
                                                    : "#fee2e2",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginBottom: "18px",
                                            }}
                                        >
                                            <i
                                                className={`fa ${disablePunch
                                                        ? "fa-check-circle text-success"
                                                        : "fa-user-times text-danger"
                                                    }`}
                                                style={{ fontSize: "40px" }}
                                            ></i>
                                        </div>

                                        <h4
                                            style={{
                                                fontWeight: "700",
                                                color: "#1e3a8a",
                                                fontSize: "24px",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            {disablePunch
                                                ? "Already Enrolled"
                                                : "Enrollment Pending"}
                                        </h4>

                                        <p
                                            style={{
                                                color: "#6b7280",
                                                fontSize: "15px",
                                                textAlign: "center",
                                                marginBottom: "0",
                                                maxWidth: "260px",
                                                lineHeight: "24px",
                                            }}
                                        >
                                            {disablePunch
                                                ? "Staff face registration has been completed successfully."
                                                : "Please enroll the staff face to continue."}
                                        </p>
                                    </div>

                                    {/* Footer */}
                                    <div
                                        className="d-flex justify-content-between align-items-center"
                                        style={{
                                            padding: "18px 18px",
                                            borderTop: "1px solid #f3f4f6",
                                        }}
                                    >
                                        <div>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    color: disablePunch
                                                        ? "#16a34a"
                                                        : "#dc2626",
                                                }}
                                            >
                                                {disablePunch
                                                    ? "✔ Verification Complete"
                                                    : "⚠ Registration Required"}
                                            </div>

                                        
                                        </div>

                                        <button
                                            className={`btn ${disablePunch
                                                    ? "btn-secondary"
                                                    : "btn-success"
                                                }`}
                                            disabled={disablePunch}
                                            onClick={handlePunchClick}
                                            style={{
                                                borderRadius: "10px",
                                                minWidth: "130px",
                                                padding: "10px 10px",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                            }}
                                        >
                                            {disablePunch ? "Enrolled" : "Enroll Now"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                          
                        </div>

                        {/* Face Recognition Stall Enrollment*/}
                       
                    </div>

                </div>

            </div>

            {/* Modal */}
            {/* {showModal && (

                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.45)",
                    }}
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">
                                    All Shift Assignments
                                </h5>

                                <button
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>

                            </div>

                            <div className="modal-body">

                                <div className="table-responsive">

                                    <table className="table table-bordered">

                                        <thead>

                                            <tr>
                                                <th>Branch</th>
                                                <th>Shift Time</th>
                                                <th>Date</th>
                                            </tr>

                                        </thead>

                                        <tbody>

                                            {/* Assignment Data */}
                                            {/* {allAssignments.assignment_data.map((item, index) => (

                                                <tr key={`assign-${index}`}>

                                                    <td>{item.assign_branchname}</td>

                                                    <td>

                                                        {item.assign_type_from
                                                            ? new Date(`1970-01-01T${item.assign_type_from}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.assign_type_to
                                                            ? new Date(`1970-01-01T${item.assign_type_to}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                    </td>

                                                    <td>

                                                        {item.assing_fromdate
                                                            ? new Date(item.assing_fromdate).toLocaleDateString("en-GB")
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.assign_todate
                                                            ? new Date(item.assign_todate).toLocaleDateString("en-GB")
                                                            : "-"}

                                                    </td>

                                                </tr>

                                            ))} */}

                                            {/* Shift Mode Data */}
                                            {/* {allAssignments.shiftmode_data.map((item, index) => (

                                                <tr key={`shift-${index}`}>

                                                    <td>{item.shiftbranch_name}</td>

                                                    <td>

                                                        {item.mode_type_from
                                                            ? new Date(`1970-01-01T${item.mode_type_from}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.mode_type_to
                                                            ? new Date(`1970-01-01T${item.mode_type_to}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                    </td>

                                                    <td>

                                                        {item.shift_from
                                                            ? new Date(item.shift_from).toLocaleDateString("en-GB")
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.shift_to
                                                            ? new Date(item.shift_to).toLocaleDateString("en-GB")
                                                            : "-"}

                                                    </td>

                                                </tr>

                                            ))}

                                        </tbody>

                                    </table>

                                </div>

                            </div>

                        </div>

                    </div>

                </div> */}

            {/* )}  */}

            {/* ── FACE ENROLLMENT MODAL ──────────────────────────────────── */}
            {enrollModalOpen && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.75)", zIndex: 9999,
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <style>{`.swal2-container { z-index: 99999 !important; }`}</style>
                    <div style={{
                        background: "#fff", borderRadius: "12px", padding: "24px",
                        width: "500px", maxWidth: "95vw", textAlign: "center",
                    }}>
                        <h5 style={{ marginBottom: "6px" }}>Register Your Face</h5>
                        <p style={{ color: "#666", fontSize: "13px", marginBottom: "12px" }}>
                            Capture 3 angles for accurate recognition. Good lighting, only your face in frame.
                        </p>
                        <div style={{ position: "relative", display: "inline-block", borderRadius: "8px", overflow: "hidden", border: "2px solid #dee2e6", width: "100%" }}>
                            <video ref={videoRef} style={{ width: "100%", display: "block", transform: "scaleX(-1)" }} playsInline muted />
                            <canvas ref={canvasRef} style={{ display: "none" }} />
                        </div>
                        {/* Step progress */}
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0", marginBottom: "8px" }}>
                                {ENROLL_STEPS.map((step, i) => (
                                    <div key={i} style={{ display: "flex", alignItems: "center" }}>
                                        <div style={{
                                            width: "30px", height: "30px", borderRadius: "50%",
                                            background: i < enrollSamples.length ? "#28a745" : i === enrollSamples.length ? "#0d6efd" : "#dee2e6",
                                            color: "white", display: "flex", alignItems: "center", justifyContent: "center",
                                            fontSize: "13px", fontWeight: "bold", flexShrink: 0,
                                        }}>
                                            {i < enrollSamples.length ? "✓" : i + 1}
                                        </div>
                                        {i < ENROLL_STEPS.length - 1 && (
                                            <div style={{ width: "36px", height: "2px", background: i < enrollSamples.length ? "#28a745" : "#dee2e6" }} />
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div style={{ fontSize: "13px", fontWeight: 600, color: enrollSamples.length >= 3 ? "#28a745" : "#0d6efd", marginBottom: "6px" }}>
                                {enrollSamples.length >= 3
                                    ? "✓ All 3 samples captured — click Register to finish"
                                    : `${ENROLL_STEPS[enrollSamples.length].icon} Step ${enrollSamples.length + 1} of 3: ${ENROLL_STEPS[enrollSamples.length].label}`}
                            </div>
                            {enrollSamples.length > 0 && (
                                <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginBottom: "8px" }}>
                                    {enrollSamples.map((img, i) => (
                                        <div key={i} style={{ textAlign: "center" }}>
                                            <img src={img} alt={`Sample ${i + 1}`} style={{
                                                width: "64px", height: "48px", objectFit: "cover",
                                                borderRadius: "4px", border: "2px solid #28a745", transform: "scaleX(-1)",
                                            }} />
                                            <div style={{ fontSize: "10px", color: "#28a745", marginTop: "2px" }}>
                                                {ENROLL_STEPS[i].icon}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Buttons */}
                        <div style={{ marginTop: "10px", display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                            {enrollSamples.length < 3 && (
                                <button className="btn btn-primary" onClick={handleEnrollStep} disabled={faceLoading || !faceCameraActive || enrollValidating}>
                                    {enrollValidating ? "Checking..." : `Capture Sample ${enrollSamples.length + 1}`}
                                </button>
                            )}
                            {enrollSamples.length > 0 && enrollSamples.length < 3 && (
                                <button className="btn btn-outline-secondary" onClick={handleEnrollRetake} disabled={faceLoading}>
                                    Retake Last
                                </button>
                            )}
                            {enrollSamples.length >= 3 && (
                                <>
                                    <button className="btn btn-success" onClick={handleEnrollSubmit} disabled={faceLoading}>
                                        {faceLoading ? "Registering..." : "Register Face"}
                                    </button>
                                    <button className="btn btn-outline-secondary" onClick={handleEnrollRetake} disabled={faceLoading}>
                                        Retake Last
                                    </button>
                                </>
                            )}
                            <button className="btn btn-secondary" onClick={closeEnrollModal} disabled={faceLoading}>
                                Cancel
                            </button>
                        </div>
                        <p style={{ marginTop: "10px", fontSize: "12px", color: "#999" }}>
                            Your face is stored securely and only used for attendance verification.
                        </p>
                    </div>
                </div>
            )}

             {/* Modal */}
            {showModal && (

                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        background: "rgba(0,0,0,0.45)",
                        backdropFilter: "blur(4px)",
                    }}
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div
                            className="modal-content border-0"
                            style={{
                                borderRadius: "24px",
                                overflow: "hidden",
                                boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                            }}
                        >

                            {/* Modal Header */}
                            <div
                                className="d-flex justify-content-between align-items-center"
                                style={{
                                    padding: "22px 28px",
                                    background:
                                        "linear-gradient(135deg, #faf8f5 0%, #f5f2ee 100%)",
                                    borderBottom: "1px solid #eee7df",
                                }}
                            >

                                <div className="d-flex align-items-center gap-3">

                                    <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "55px",
                                            height: "55px",
                                            borderRadius: "18px",
                                            background: "#eef3e8",
                                        }}
                                    >

                                        <i
                                            className="ti-calendar"
                                            style={{
                                                fontSize: "24px",
                                                color: "#5f7c4d",
                                            }}
                                        ></i>

                                    </div>

                                    <div>

                                        <h4
                                            className="mb-1 fw-bold"
                                            style={{
                                                color: "#4e3f39",
                                            }}
                                        >
                                            All Shift Assignments
                                        </h4>

                                        <p
                                            className="mb-0"
                                            style={{
                                                color: "#8a7d75",
                                                fontSize: "13px",
                                            }}
                                        >
                                            Complete shift assignment history
                                        </p>

                                    </div>

                                </div>

                                {/* Close Button */}
                                <button
                                    className="btn"
                                    onClick={() => setShowModal(false)}
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "50%",
                                        background: "#fff",
                                        border: "1px solid #eee7df",
                                        color: "#6d5d55",
                                        fontSize: "18px",
                                    }}
                                >

                                    <i className="ti-close"></i>

                                </button>

                            </div>

                            {/* Modal Body */}
                            <div
                                className="modal-body"
                                style={{
                                    padding: "25px",
                                    background: "#fcfbf9",
                                }}
                            >

                                <div className="table-responsive" style={{
                                    maxHeight: "350px",
                                    overflowY: "auto",
                                    overflowX: "auto",
                                }}>

                                    <table className="table align-middle">

                                        <thead>

                                            <tr
                                                style={{
                                                    background: "#f7f4f0",
                                                }}
                                            >

                                                <th>Branch</th>
                                                <th>Shift</th>
                                                <th>Date</th>

                                            </tr>

                                        </thead>
<tbody>

                                            {/* Assignment Data */}
                                             {allAssignments.assignment_data.map((item, index) => (

                                                <tr key={`assign-${index}`}>

                                                    <td>{item.assign_branchname}</td>

                                                    <td>

                                                        {item.assign_type_from
                                                            ? new Date(`1970-01-01T${item.assign_type_from}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.assign_type_to
                                                            ? new Date(`1970-01-01T${item.assign_type_to}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                    </td>

                                                    <td>

                                                        {item.assing_fromdate
                                                            ? new Date(item.assing_fromdate).toLocaleDateString("en-GB")
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.assign_todate
                                                            ? new Date(item.assign_todate).toLocaleDateString("en-GB")
                                                            : "-"}

                                                    </td>

                                                </tr>

                                            ))} 

                                            {/* Shift Mode Data */}
                                            {allAssignments.shiftmode_data.map((item, index) => (

                                                <tr key={`shift-${index}`}>

                                                    <td>{item.shiftbranch_name}</td>

                                                    <td>

                                                        {item.mode_type_from
                                                            ? new Date(`1970-01-01T${item.mode_type_from}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.mode_type_to
                                                            ? new Date(`1970-01-01T${item.mode_type_to}`).toLocaleTimeString([], {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true,
                                                            })
                                                            : "-"}

                                                    </td>

                                                    <td>

                                                        {item.shift_from
                                                            ? new Date(item.shift_from).toLocaleDateString("en-GB")
                                                            : "-"}

                                                        {" "}to{" "}

                                                        {item.shift_to
                                                            ? new Date(item.shift_to).toLocaleDateString("en-GB")
                                                            : "-"}

                                                    </td>

                                                </tr>

                                            ))}

                                        </tbody>
                                       

                                    </table>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            )}
        </>

    );

}

export default DashboardElement;